import React, { Component, Suspense, lazy } from "react";
import { classnames, Loader, PlainButton } from "@culturehq/components";

import ResponseRate from "./ResponseRate";

const SurveyItemResultDisplay = lazy(() => import("./SurveyItemResultDisplay"));

class SurveyItemResult extends Component {
  constructor(props) {
    super(props);

    this.state = { open: props.open };
  }

  handleOpenToggle = event => {
    event.preventDefault();
    event.stopPropagation();

    this.setState(({ open }) => ({ open: !open }));
  };

  render() {
    const {
      itemNumber,
      surveyItem,
      results,
      overallResponseCount,
      isRatingItem,
      potentialRespondents
    } = this.props;

    const { open } = this.state;

    return (
      <div className={classnames("survey-item-result", { open })}>
        <div onClick={this.handleOpenToggle} className="clickable">
          <PlainButton onClick={this.handleOpenToggle} className="pull-right toggle">
            {open ? "-" : "+"}
          </PlainButton>
          <h2>Q{itemNumber}. {surveyItem.prompt}</h2>
        </div>
        {open && (
          <>
            <Suspense fallback={<Loader loading />}>
              <SurveyItemResultDisplay
                surveyItem={surveyItem}
                surveyItemResult={results}
              />
            </Suspense>
            <ResponseRate
              itemResponseCount={results && results.responseCount}
              overallResponseCount={overallResponseCount}
              isRatingItem={isRatingItem}
              potentialRespondents={potentialRespondents}
            />
          </>
        )}
      </div>
    );
  }
}

export default SurveyItemResult;
